import Vue from 'vue'
import Router from 'vue-router'

// routes
import Login from '@/pages/login/routes.login'

/* Global Components */
/* -----Offset Heading----- */
import OffsetHeading from '@/components/custom-components/OffsetHeading'
Vue.component('offset-heading', OffsetHeading)
Vue.component('offset-block', () => import('@/components/custom-components/OffsetBlock'))
Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [...Login]
})

export default router
